export default __webpack_public_path__ + "static/media/dlt.1129c53a.svg";